function runValidation(form, formfields, validationObject, schema, callback) {
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    const values = { ...validationObject() };

    // Βγάζω όλα τα display block και τα κάνω hidden για να τρέξει ξανά το validation και να εμφανίσει όσα έχουν errors
    for (const fieldName in formfields) {
      if (formfields.hasOwnProperty(fieldName)) {
        if (form.querySelector(`.${fieldName}error`)) {
          form
            .querySelector(`.${fieldName}error`)
            .setAttribute("aria-hidden", true);
        }
      }
    }

    // Τρέχω το validation στο schema
    schema
      .validate(values, { abortEarly: false })
      .then(function () {
        // Email is valid
        callback(values);
      })
      .catch(function (error) {
        // Validation failed, show an error message
        // console.log({ ...error })

        for (const validationError of error.inner) {
          const fieldName = validationError.path; // Field name with error
          const errorMessage = validationError.message; // Error message

          // Show or handle the error message for the specific field
          let errorField = form.querySelector(`.${fieldName}error`);
          errorField.setAttribute("aria-hidden", false);
          errorField.innerHTML = errorMessage;
        }
      });
  });
}

// function runValidationOnBlur(form, formfields, validationObject, schema) {
//   // Attach blur event listener to each form field
//   for (const fieldName in formfields) {
//     if (formfields.hasOwnProperty(fieldName)) {
//       console.log(
//         "typeof fieldName",
//         typeof formfields[fieldName],
//         fieldName,
//         formfields[fieldName],
//       );
//       const inputField = formfields[fieldName];

//       // Add the appropriate event according to the input
//       function addEventListener() {
//         if (
//           inputField.type == "text" ||
//           inputField.tagName.toLowerCase() === "textarea"
//         ) {
//           return "blur";
//         }
//         if (inputField.type == "checkbox") {
//           return "click";
//         }
//         if (inputField.tagName.toLowerCase() === "select") {
//           return "change";
//         }
//       }

//       inputField.addEventListener(addEventListener(), function () {
//         // Hide any existing error messages for this field
//         const errorField = form.querySelector(`.${fieldName}error`);
//         errorField.setAttribute("aria-hidden", true);

//         // Run validation for the specific field
//         schema
//           .validateAt(fieldName, validationObject(), { abortEarly: false })
//           .then(function () {
//             // Field is valid
//           })
//           .catch(function (error) {
//             // Validation failed, show an error message for the specific field
//             const errorMessage = error.errors[0]; // Assuming only one error is shown at a time

//             errorField.setAttribute("aria-hidden", false);
//             errorField.innerHTML = errorMessage;
//           });
//       });
//     }
//   }

//   // Handle form submission as before
//   form.addEventListener("submit", function (e) {
//     e.preventDefault();

//     // ... Rest of your form submission logic
//   });
// }

function runValidationOnBlur(form, formfields, validationObject, schema) {
  // Attach blur event listener to each form field
  for (const fieldName in formfields) {
    if (formfields.hasOwnProperty(fieldName)) {
      const inputField = formfields[fieldName];

      // Check if the field is a NodeList (e.g., checkbox group)
      if (
        NodeList.prototype.isPrototypeOf(inputField) ||
        Array.isArray(inputField)
      ) {
        // Add event listener to each checkbox in the group
        inputField.forEach((checkbox) => {
          checkbox.addEventListener("click", function () {
            validateField(fieldName, form, validationObject, schema);
          });
        });
      } else {
        // Add the appropriate event for single inputs
        const eventType = getEventType(inputField);
        inputField.addEventListener(eventType, function () {
          validateField(fieldName, form, validationObject, schema);
        });
      }
    }
  }

  // Handle form submission
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    // You can run a full schema validation here
    schema
      .validate(validationObject(), { abortEarly: false })
      .then(() => {
        console.log("Form is valid!");
      })
      .catch((error) => {
        console.error("Validation failed:", error.errors);
      });
  });

  function getEventType(inputField) {
    if (
      inputField.type === "text" ||
      inputField.tagName.toLowerCase() === "textarea"
    ) {
      return "blur";
    }
    if (inputField.type === "checkbox") {
      return "click";
    }
    if (inputField.tagName.toLowerCase() === "select") {
      return "change";
    }
    return "blur"; // Fallback event type
  }

  function validateField(fieldName, form, validationObject, schema) {
    // Hide any existing error messages for this field
    const errorField = form.querySelector(`.${fieldName}error`);
    if (errorField) {
      errorField.setAttribute("aria-hidden", true);
      errorField.innerHTML = ""; // Clear previous errors
    }

    // Run validation for the specific field
    schema
      .validateAt(fieldName, validationObject(), { abortEarly: false })
      .then(() => {
        console.log(`Field '${fieldName}' is valid.`);
      })
      .catch((error) => {
        // Validation failed, show an error message for the specific field
        if (errorField) {
          errorField.setAttribute("aria-hidden", false);
          errorField.innerHTML = error.errors[0]; // Show the first error message
        }
      });
  }
}

export { runValidationOnBlur, runValidation };
